import { useState } from "react";
import { Clapperboard, ExternalLink } from "lucide-react";

const OVERLAYS = [
  { key: "wind", label: "Vento" },
  { key: "gust", label: "Raffiche" },
  { key: "rain", label: "Pioggia" },
];

const METEOSWISS = [
  { label: "MeteoSvizzera · Precipitazioni", url: "https://www.meteosvizzera.admin.ch/servizi-e-pubblicazioni/applicazioni/precipitazioni.html" },
  { label: "MeteoSvizzera · Vento", url: "https://www.meteosvizzera.admin.ch/servizi-e-pubblicazioni/applicazioni/vento.html#tab=animation-wind-10m" },
];

export function AnimatedMaps({ spot }) {
  const [overlay, setOverlay] = useState("wind");
  const lat = spot?.latitude ?? 45.78;
  const lon = spot?.longitude ?? 10.83;

  const src =
    `https://embed.windy.com/embed2.html?lat=${lat}&lon=${lon}` +
    `&detailLat=${lat}&detailLon=${lon}&zoom=9&level=surface&overlay=${overlay}` +
    `&product=ecmwf&menu=&message=true&marker=true&calendar=now&pressure=&type=map` +
    `&location=coordinates&detail=&metricWind=kt&metricTemp=%C2%B0C&radarRange=-1`;

  return (
    <div className="bg-white rounded-3xl border border-slate-100 shadow-sm overflow-hidden" data-testid="animated-maps">
      <div className="flex flex-wrap items-center gap-3 px-5 pt-5 pb-3">
        <div className="h-8 w-8 rounded-xl bg-sky-100 flex items-center justify-center">
          <Clapperboard className="h-4 w-4 text-sky-600" />
        </div>
        <h3 className="font-head text-xl font-semibold text-slate-900">Mappe animate · {spot?.name}</h3>
      </div>

      <div className="flex gap-2 px-5 pb-4">
        {OVERLAYS.map((o) => (
          <button
            key={o.key}
            onClick={() => setOverlay(o.key)}
            data-testid={`map-overlay-${o.key}`}
            className={`shrink-0 rounded-full px-4 py-1.5 text-sm font-head font-semibold border transition-colors duration-200 ${
              overlay === o.key
                ? "bg-sky-600 border-sky-600 text-white"
                : "bg-white border-slate-200 text-slate-600 hover:border-sky-300"
            }`}
          >
            {o.label}
          </button>
        ))}
      </div>

      <div className="w-full bg-slate-100 border-t border-slate-100">
        <iframe
          key={overlay}
          src={src}
          title={`Windy ${overlay} ${spot?.name}`}
          className="w-full"
          style={{ height: 440, border: 0 }}
          frameBorder="0"
          data-testid="windy-iframe"
        />
      </div>

      <div className="px-5 py-3 flex flex-wrap gap-x-5 gap-y-1">
        <span className="text-[11px] text-slate-400">Animazioni live via Windy. Anche su MeteoSvizzera:</span>
        {METEOSWISS.map((m) => (
          <a
            key={m.url}
            href={m.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="meteoswiss-link"
            className="inline-flex items-center gap-1 text-[11px] font-semibold text-sky-600 hover:text-sky-700"
          >
            {m.label} <ExternalLink className="h-3 w-3" />
          </a>
        ))}
      </div>
    </div>
  );
}
